import {Injectable} from "@angular/core";
import {UiNotification} from "@pt/pt-models";
import {share, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class InlineNotificationService {

  private notification$: Subject<UiNotification> = new Subject<UiNotification>();

  public dispatchNotification(notification: UiNotification) {
    this.notification$.next(notification);
  }

  public listenNotification() {
    return this.notification$.pipe(share());
  }
}
